export default __webpack_public_path__ + "static/media/ERI_Schedule.9a5e0859.png";